import React, { useState, useEffect, useRef } from 'react';
import { 
  Building, Search, ShieldCheck, Briefcase, Wheat, Droplet, 
  Cookie, CupSoda, Container, Beef, MapPin, Award, Truck, Target
} from 'lucide-react';
import { mockData } from '../../mock';

const iconMap = {
  building: Building,
  search: Search,
  'shield-check': ShieldCheck,
  briefcase: Briefcase,
  wheat: Wheat,
  droplet: Droplet,
  cheese: Cookie,
  'cup-soda': CupSoda,
  container: Container,
  beef: Beef,
  'map-pin': MapPin,
  award: Award,
  truck: Truck,
  target: Target
};

const WhyChooseSection = () => {
  const [whyChooseAnimated, setWhyChooseAnimated] = useState(false);
  const whyChooseRef = useRef(null);

  useEffect(() => {
    const whyChooseObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !whyChooseAnimated) {
          setWhyChooseAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (whyChooseRef.current) {
      whyChooseObserver.observe(whyChooseRef.current);
    }

    return () => {
      if (whyChooseRef.current) {
        whyChooseObserver.unobserve(whyChooseRef.current);
      }
    };
  }, [whyChooseAnimated]);

  return (
    <section 
      id="why-us" 
      className="py-20 px-6 bg-gradient-to-br from-amber-50 via-stone-50 to-orange-50"
      ref={whyChooseRef}
    >
      <div className={`container mx-auto max-w-7xl ${whyChooseAnimated ? 'whychoose-animate-active' : 'whychoose-animate-ready'}`}>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-900 font-semibold tracking-wide uppercase text-sm whychoose-label">
            Why Choose ALL-FOOD
          </span>
          <h2 className="md:text-5xl !font-bold !text-4xl mt-3 mb-6 text-stone-900">
            <span className="whychoose-headline">
              Why buyers <span className="text-blue-900">choose ALL-FOOD</span>
            </span>
          </h2>
          <p className="text-lg text-stone-600 whychoose-subtext">
            We combine local expertise with international standards to deliver exceptional value.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockData.whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div key={item.id} className="text-center space-y-4 group">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto group-hover:bg-blue-900 transition-colors duration-300">
                  <IconComponent className="text-blue-900 group-hover:text-white transition-colors duration-300" size={32} />
                </div>
                <h3 className="text-xl font-bold text-stone-900">
                  {item.title}
                </h3>
                <p className="text-stone-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
